import { faChevronDown, faChevronUp, faCopy } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"

export default function PromptCard({ prompt, expandCards }) {

    //STATE
    const [ showCopied, setShowCopied ] = useState( false )
    const [ expandCard, setExpandCard ] = useState( expandCards )

    //FUNCTIONS
    const copyPrompt = ( text ) => {
        navigator.clipboard.writeText( text ) 
        setShowCopied( true )
    }

    //EFFECTS
    useEffect(() => {
        if( showCopied ){
            setTimeout(() => {
                setShowCopied( false )
            }, 1000)
        }
    }, [ showCopied ])

    useEffect(() => {
        setExpandCard( expandCards )
    }, [ expandCards ])
    
    return(
        <div className="prompt-card ">
            <div className={`copied-tag ${showCopied ? 'reveal': ''}`} onClick={ () => copyPrompt( prompt.content) } >
                <p>Copied</p>
            </div>
            <div className="prompt-card-inner round-div">
                <h4>{ prompt.title }</h4>
                {
                    expandCard &&
                    <p>{ prompt.content }</p>
                }
                <div className="prompt-icon-container copy-icon" onClick={ () => copyPrompt( prompt.content) }>
                    <FontAwesomeIcon icon={ faCopy } className="prompt-icon"/>
                </div>
                <div className="prompt-expand-icon-container" onClick={ () => setExpandCard( ! expandCard ) }>
                    <FontAwesomeIcon icon={ !expandCard ? faChevronDown : faChevronUp } className="prompt-icon"/>
                </div>
            </div>
        </div>
    )
}